import React from 'react';

function ScorecardVacation({ rollups }) {
  return (
    <div className="scorecard-section">
      <h2>Vacation &amp; Time Off</h2>
      <div className="vacation-summary-table">
        <div className="summary-item">
          <span className="label">Approved Total:</span>
          <span className="value">{rollups.vacationTotal} days</span>
        </div>
        <div className="summary-item">
          <span className="label">Days Used:</span>
          <span className="value">{rollups.vacationUsed} days</span>
        </div>
        <div className="summary-item">
          <span className="label">Days Scheduled:</span>
          <span className="value">{rollups.vacationScheduled} days</span>
        </div>
        <div className="summary-item">
          <span className="label">Policy Model:</span>
          <span className="value">Approval-based</span>
        </div>
      </div>
    </div>
  );
}

export default ScorecardVacation;
